<script setup lang="ts">
import { computed, ref, reactive, onMounted } from 'vue'
import { useGlobalStore } from '@/pinia/GlobalStore'
import { useNotificationStore } from '@/pinia/NotificationStore'
import { closeDialog } from 'vue3-promise-dialog'

import { type IKeyValueMulitTypeStore } from '@/types'

export interface Props {
  open: boolean
}

const isSaving = ref<boolean>(false)
const notificationStore = useNotificationStore()

defineProps<Props>()
const globalStore = useGlobalStore()

const form = reactive({
  'current-password': '',
  'new-password': '',
  'confirm-password': ''
})
const formRef = ref()
const errors = computed(() => formRef.value?.errors || null)
const error = ref('')

const onClose = () => {
  closeDialog(false)
}

const onSuccess = async (values: IKeyValueMulitTypeStore) => {
  error.value = null
  try {
    await globalStore.changePassword({
      currentPassword: values['current-password'],
      newPassword: values['new-password']
    })
    notificationStore.addClientNotification(
      {
        title: 'Kennwort ändern',
        text: 'Dein Kennwort wurde erfolgreich geändert.',
        variant: 'success'
      })
    isSaving.value = false
    closeDialog(true)
  } catch (e) {
    error.value = e.response.data
    isSaving.value = false
  }
}

</script>
<template>
  <storm-ui-dialog
    :show="open"
    height="auto"
    width="sm"
    title="Kennwort ändern"
    @hide="onClose"
  >
    <template #content>
      <storm-ui-form-errors
        :errors="errors"
      />
      <storm-ui-alert
        v-show="error"
        title="Ups, das hat nicht funktioniert."
        class="p-4"
      >
        <p>{{ error }}</p>
      </storm-ui-alert>
      <storm-ui-form
        id="password-form"
        ref="formRef"
        :initial-values="form"
        @success="onSuccess"
        @request="isSaving = true"
      >
        <storm-ui-form-group>
          <div class="col-span-12">
            <storm-ui-input
              id="current-password"
              autofocus
              autocomplete="current-password"
              rules="required"
              type="password"
              name="current-password"
              label="Aktuelles Kennwort"
            />
          </div>
        </storm-ui-form-group>
        <storm-ui-password-change :form-ref="formRef" />
      </storm-ui-form>
    </template>
    <template #footer>
      <div class="flex-1 flex items-center px-4">
        <div class="flex-1 space-x-2 text-right">
          <storm-ui-button
            variant="link"
            type="button"
            @click="onClose"
          >
            Abbrechen
          </storm-ui-button>
          <storm-ui-button
            type="submit"
            :loading="isSaving"
            form="password-form"
            variant="primary"
          >
            Speichern
          </storm-ui-button>
        </div>
      </div>
    </template>
  </storm-ui-dialog>
</template>
